<template>
  <div class="techer-card"  @click="btnClick(info.url)">
    <!-- <img src="@/assets/tianliteacher.png" alt="" /> -->
    <img v-complete:src="info.image" alt="" />
    <p class="teacher-hand">{{ info.title }}</p>
    <p class="box-line"></p>
    <p class="box-info" v-html="info.descr"></p>
    <!-- <el-button
      type="primary"
      round
      @click="btnClick(info.url)"
      :style="{ background: info.botton_color,borderColor:info.botton_color }"
      >查看详情</el-button
    > -->
  </div>
</template>

<script setup>
import { useIdGetUrl } from "@/utils/slide.js";
import { reactive } from "vue";
import { useRouter } from "vue-router";

let router = useRouter();

const mydata = reactive({
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

setTimeout(() => {
  // console.log('info',props.info);
}, 3000);

const props = defineProps({
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

// 按钮点击事件
function btnClick(path) {
  // 获取地址
  // let path = useIdGetUrl(id);
  // 进行跳转
  // router.push({ path });
  // window.open(path)
  // 如果是完整地址，那么先分割成数组再进行跳转；如果不是完整地址，那么直接跳转
  if (
    path.includes("http://") ||
    path.includes("https://") ||
    path.includes("#")
  ) {
    router.push({ path: path.split("#")[1] });
  } else {
    router.push({ path: path });
  }
}
</script>

<style scoped lang="scss">
.techer-card {
  width: 202px;
  height: 244px;
  border:1px solid #0000001A;
  // border:1px solid #0000001A;
  // box-shadow: 0px 5px 40px 0px #0000000d;
  // border-radius:8px;
  text-align: center;
  //  line-height: 397px;
  padding: 18px 30px;
  border-radius:8px;

  > img {
    display: block;
    width: 76px;
    height: 76px;
    margin: 0 auto;
    // margin-top: 56px;
    margin-bottom: 4px;
  }
  > p {
    height: 32px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  > .teacher-hand {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 4px;
  }
  .box-line {
    width: 31px;
    height: 1px;
    background-color: #009de0;
    margin: 0 auto;
    margin-bottom: 4px;
  }

  .box-info {
    width: 143px;
    height: 88px;
    line-height: 22px;
    margin: 0 auto;
    // border:1px solid red;
  }
  :deep(.el-button) {
    margin-top: 27px;
  }
  :deep(.el-button.el-button--primary.is-round) {
    border: 1px solid #009de0;
    width: 162px;
    // height: 32px;
  }
  :deep(.el-button.el-button--primary.is-round > span) {
    color: #ffffff !important;
    font-size: 16px;
  }
}
</style>
